/**
 * UranIA PA — AI Disclosure banner state (US-011).
 *
 * Zustand store in-memory che tiene il flag `dismissed` del banner AI Act
 * art. 50 (L. 132/2025). Lo stato è volatile per design (AC#2 letterale
 * "non-permanent dismiss"): un refresh / nuova sessione riporta il banner
 * a visibile. Per questo motivo NON si usa `persist` middleware.
 *
 * Boundary (analisi §19 compliance):
 *   - Il dismiss è una *acknowledgement* dell'utente, non una preferenza
 *     a lungo termine — la disclosure AI Act art. 50 deve poter essere
 *     ripresentata ad ogni nuovo accesso (best practice AGCOM / AGID +
 *     Garante Privacy provv. 9/2025 §4).
 */

import { create } from 'zustand';

export interface AiDisclosureBannerState {
  readonly dismissed: boolean;
  readonly dismiss: () => void;
  readonly reset: () => void;
}

export const useAiDisclosureBannerStore = create<AiDisclosureBannerState>((set) => ({
  dismissed: false,
  dismiss: (): void => {
    set({ dismissed: true });
  },
  reset: (): void => {
    set({ dismissed: false });
  },
}));

export const selectAiDisclosureDismissed = (state: AiDisclosureBannerState): boolean =>
  state.dismissed;
